import type { Position } from './StationMapCore';

export function smoothPanTo(
    map: google.maps.Map | null,
    target: Position,
) {
    if (!map || !target) return;

    const start = map.getCenter();
    if (!start) {
        map.panTo(target);
        return;
    }

    const startLat = start.lat();
    const startLng = start.lng();
    const endLat = typeof target.lat === 'function'
        ? (target as google.maps.LatLng).lat()
        : (target as google.maps.LatLngLiteral).lat;
    const endLng = typeof target.lng === 'function'
        ? (target as google.maps.LatLng).lng()
        : (target as google.maps.LatLngLiteral).lng;

    const duration = 400;
    const startTime = performance.now();

    function step(timestamp: number) {
        if (!map) return;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = 1 - (1 - progress) ** 3;

        map.setCenter({
            lat: startLat + (endLat - startLat) * ease,
            lng: startLng + (endLng - startLng) * ease,
        });

        if (progress < 1) {
            requestAnimationFrame(step);
        }
    }

    requestAnimationFrame(step);
}
